import React from 'react';
import { isNil } from 'lodash';
import {
  prefix,
  DEFAULT_TAG
} from './flex.constants';
import { FlexProps } from './flex.models';
import { generateFlexClasses } from './flex.utilities';

const defaultProps = {
  tag: DEFAULT_TAG // 'div'
};

export const FlexLayout = (props: FlexProps): JSX.Element => {
  const { children, tag, id, isRender } = props;

  if (!isNil(isRender) && !isRender) {
    return null;
  }

  const flexClasses = generateFlexClasses(props, prefix.LAYOUT);
  const layoutProps = { className: flexClasses, id };

  const layout = React.createElement(tag, layoutProps, children);
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {layout}
    </>
  );
};

FlexLayout.defaultProps = defaultProps;
